
import React from "react";
import { useNavigate } from "react-router-dom";

export default function TradingInformationSubmitted() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: 32,
        textAlign: "center",
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      {/* ✅ Success image */}
      <img
  src="/onboarding-success.png"
  alt="Onboarding complete"
  style={{
    width: 396,
    height: 496,
    marginBottom: 16,
  }}
/>


      <h2 style={{ color: "green", marginTop: 0 }}>
        ✅ Onboarding Complete
      </h2>

      <p style={{ color: "#555", marginBottom: 24 }}>
        Your trading account information has been submitted successfully. You will receive a confirmation when your trading account is available for funding.
      </p>

      <button
        onClick={() => navigate("/Dashboard")}
        style={{
          padding: "10px 20px",
          borderRadius: 8,
          border: "none",
          background: "#FFD700",
          color: "#111",
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Return to Dashboard
      </button>
    </div>
  );
}
